import React, { Component } from 'react'
import moment from "moment"
import { Collapse, message, Alert } from 'antd';
import { Link } from "react-router-dom"
import classnames from 'classnames'
import course from '../course/course';
const { Panel } = Collapse;

class CourseInfoDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sections: [],
      course: {},
      active: 0
    }
  }
  componentWillMount() {
    this.setState({ sections: this.props.section, course: this.props.course })
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ sections: nextProps.section, course: nextProps.course })

  }
  checkHours = (num) => {
    let hours = Math.floor(num / 3600);
    return hours
  }
  callback = (key) => {
    if (key) this.setState({ active: key })
  }
  playLect = (e, activeLect) => {
    if (this.props.auth.isEmpty) return message.error("Please login to continue")
    this.props.getUserAndAddCourse(this.state.course.id)
    e.preventDefault();
    this.props.updatePlaylist(activeLect)
    setTimeout(() => {
      this.props.history.push(this.props.match.url + '/lectures')
    }, 1000);
  }
  play = () => {
    if (this.props.auth.isEmpty) return message.error("Please login to continue")
    // var lastViewed = {
    //   course: this.state.course,
    //   section: this.state.sections[0],
    //   activeLecture: this.state.sections[0].lectures[0]
    // }
    this.props.history.push(this.props.match.url + '/lectures')
    this.props.getUserAndAddCourse(this.state.course.id)
  }
  render() {
    const { sections, course, active } = this.state
    return (
      <div className="course-details">
        
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-xs-12">
              <div className="details-wrapper">
                <div className="course-title">
                  <h2>{course.title}</h2>
                  <span>Posted on {moment(course.created).format("LL")}</span>
                </div>


                <div className="curriculum-panel">
                  <div className="clearfix">
                    <h3 className="float-left">Curriculum</h3>
                    <ul className="float-right">
                      <li><span>{course.lessons} </span> Lectures</li>
                      <li><span>{this.checkHours(course.duration) ? moment.utc(course.duration * 1000).format('hh:mm:ss') : moment.utc(course.duration * 1000).format('mm:ss')}</span></li>
                    </ul>
                  </div>
                  <div className="panel-group theme-accordion" id="accordionTwo">
                    <Collapse bordered={false} accordion={true} defaultActiveKey={active} onChange={this.callback}>
                      {sections.map((sec, index) => (<Panel key={index} showArrow={false} header={<div className={classnames('panel-heading', active == index ? 'active-panel' : null)}>
                        <h5 className="panel-title">
                          <a data-toggle="collapse" className="clearfix" >
                            <h6 className="float-left">
                              <span>Lecture {index + 1}</span>
                              {sec.title}
                            </h6>
                            <p className="float-right">{this.checkHours(sec.duration) ? moment.utc(sec.duration * 1000).format('hh:mm:ss') + ' hr' : moment.utc(sec.duration * 1000).format('mm:ss') + ' min'} </p>
                          </a>
                        </h5>
                      </div>} key={index}>
                        <div id={`#collapse${sec.id}`} className="panel-collapse collapse in">
                          <div className='panel-body'>
                            <ul>
                              {
                                sec.lectures.map((lec, key) => (
                                 <ul>
                                 <li key={key} className="clearfix">
                                    <span className="float-left"><i className="fa fa-play-circle" aria-hidden="true"></i>
                                      <span className="title">{lec.title} </span><Link to="#" onClick={e => this.playLect(e, lec)} className="tran3s preview p-bg-color">Watch </Link></span>
                                    <span className="float-right">{this.checkHours(lec.duration) ? moment.utc(lec.duration * 1000).format('hh:mm:ss') : moment.utc(lec.duration * 1000).format('mm:ss')} min</span>
                                    
                                  </li>
                                  {lec.files && lec.files.map((file)=>(
                                         <li key={key} className="clearfix" style={{marginLeft:"8.5em"}}>
                                         <span className="float-left"><i className="fa fa-file" aria-hidden="true"></i>
                                           <span className="title">{file.name} </span></span>
                                           {!this.props.auth.isEmpty && <a style={{color:"#000"}}  href={file.url} className="float-right">Download</a>}
                                       </li> 
                                    ))}
                                  </ul>
                                ))}
                            </ul>
                          </div>
                        </div>
                      </Panel>))}

                    </Collapse>

                  </div>
                </div>


                <h3>Description</h3>
                <p className="p1">{course.description}</p>
                <div className="learn-list">
                  <h3>What Will I Learn?</h3>
                  <ul className="row">
                    {course.youWillLearn.map((item, key) => (
                      <li key={key} className="col-sm-6 col-xs-12"><span>{item}</span>
                      </li>
                    ))}

                  </ul>
                </div>
              </div>
            </div>


            <div className="col-md-4 col-sm-6 col-xs-12">
              <div className="course-sidebar">
                <div className="sidebar-course-information">

                  <ul className="info-list row">
                    <li className="col-xs-6"><b>Lectures :</b> {course.lessons}</li>
                    <li className="col-xs-6"><b>Skill :</b> General</li>
                    <li className="col-xs-6"><b>Language :</b> English</li>
                    <li className="col-xs-6"><b>Duration :</b> {this.checkHours(course.duration) ? moment.utc(course.duration * 1000).format('hh:mm:ss') : moment.utc(course.duration * 1000).format('mm:ss')}</li>
                  </ul>
                  {/* <div>
                    <ul className="clearfix student-image">
                      <li><img src="/img/courses/24.jpg" alt="" /></li>
                      <li><img src="/img/courses/25.jpg" alt="" /></li>
                      <li><img src="/img/courses/26.jpg" alt="" /></li>
                      <li><img src="/img/courses/27.jpg" alt="" /></li>
                      <li>
                        <div className="image">
                          <img src="/img/courses/24.jpg" alt="" />
                          <div className="opacity">150+</div>
                        </div>
                      </li>
                    </ul>
                    <p><b>5</b> Students Enrolled</p>
                  </div> */}
                  {this.props.lastViewCourse.id === course.id?
                  <Link to="#" onClick={this.play} className="tran3s s-bg-color take-course hvr-trim" style={{background:"#222"}}>
                 Pickup where you left </Link>:
                  <Link to="#" onClick={this.play} className="tran3s s-bg-color take-course hvr-trim">
                  Take this course </Link>}
                 
                  {this.props.firebase.profile.role === 'admin' && <Link style={{ marginTop: "1em" }} to={'/editcourse/' + course.slug} className="tran3s s-bg-color take-course hvr-trim">Edit this course</Link>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}
export default CourseInfoDetails